import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { AppModule, HEADER_CONFIG } from './app.module';
import { removeVersionInterceptorFn } from './gea/interceptor/remove-version.interceptor';
import { provideGeaCustom } from './gea/provide/provide-gea';

export const appConfig: ApplicationConfig = {
  providers: [
    provideGeaCustom(HEADER_CONFIG),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withFetch(),
      withInterceptors([removeVersionInterceptorFn]),
      withInterceptorsFromDi(),
    ),
    importProvidersFrom(AppModule),
  ],
};
